import * as PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Popup from '../../../common/Popup';
import { optionsValues } from './consts/options';
import { LabTestHistoryContext } from './state/context';
import { LabTestHistoryList } from './LabTestHistoryList';
import { LabTestHistoryGraph } from './LabTestHistoryGraph';
import { LabTestHistoryHeader } from './LabTestHistoryHeader';
import { LabTestHistorySelector } from './LabTestHistorySelector';

import { enhance } from './enhance';

import styles from './index.styl';

function LabTestHistoryModal({
  intl,
  data,
  name,
  error,
  close,
  userId,
  pending,
  targetUserId,
  componentCode,
  getLabResultHistoryReq,
  getLabResultHistoryClear,
  openedLabResultHistoryModal,
}) {
  const { formatMessage } = intl;
  const [option, setOption] = useState(optionsValues.FIVE);
  const [endDate, setEndDate] = useState();
  const [startDate, setStartDate] = useState();

  useEffect(() => {
    setOption(optionsValues.FIVE);
  }, []);

  useEffect(() => {
    if (openedLabResultHistoryModal) {
      if (Boolean(componentCode)) {
        if (option === optionsValues.FIVE || option === optionsValues.TEN) {
          getLabResultHistoryReq({
            componentCode,
            limit: option,
            userId: targetUserId || userId,
          });
        }
        if (option === optionsValues.ALL) {
          getLabResultHistoryReq({
            componentCode,
            userId: targetUserId || userId,
          });
        }
      }
    }
  }, [openedLabResultHistoryModal, option, userId, targetUserId]);

  useEffect(() => {
    if (Boolean(componentCode)) {
      if (
        startDate &&
        startDate.length === 10 &&
        endDate &&
        endDate.length === 10 &&
        option === optionsValues.CUSTOM
      ) {
        getLabResultHistoryReq({
          componentCode,
          endTime: endDate,
          startTime: startDate,
          userId: targetUserId || userId,
        });
      }
    }
  }, [startDate, endDate, userId, targetUserId]);

  function handleCloseModal() {
    setStartDate('');
    setEndDate('');
    setOption(optionsValues.FIVE);
    getLabResultHistoryClear();
    close();
  }

  return (
    <Popup
      title={formatMessage({
        id: 'patient.healthboard.labTestHistory.modalTitle',
      })}
      onClose={handleCloseModal}
      opened={openedLabResultHistoryModal}
      mobileFullScreen={false}
      overflowVisible
      width="auto"
      strictClose
    >
      <div className={styles.wrapper}>
        <LabTestHistoryContext.Provider
          value={{
            data,
            name,
            intl,
            error,
            close,
            option,
            pending,
            endDate,
            startDate,
            setOption,
            setEndDate,
            setStartDate,
            formatMessage,
            getLabResultHistoryClear,
          }}
        >
          <LabTestHistoryHeader />
          <LabTestHistorySelector />
          <LabTestHistoryGraph />
          <LabTestHistoryList />
        </LabTestHistoryContext.Provider>
      </div>
    </Popup>
  );
}

LabTestHistoryModal.propTypes = {
  data: PropTypes.array,
  close: PropTypes.func,
  name: PropTypes.string,
  intl: PropTypes.object,
  error: PropTypes.string,
  pending: PropTypes.bool,
  userId: PropTypes.number,
  targetUserId: PropTypes.number,
  componentCode: PropTypes.string,
  getLabResultHistoryReq: PropTypes.func,
  getLabResultHistoryClear: PropTypes.func,
  openedLabResultHistoryModal: PropTypes.bool,
};

export default enhance(LabTestHistoryModal);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/index.jsx